import script from "./DateRangePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateRangePicker.vue?vue&type=script&lang=ts&setup=true"

import "./DateRangePicker.vue?vue&type=style&index=0&id=a5fa8426&lang=scss&scoped=true"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5fa8426"]])

export default __exports__